import {
  CREATE_RMA_FEE,
  DELETE_RMA_FEE,
  EDIT_RMA_FEE,
  RECEIVE_RMA_FEES,
  REQUEST_ALL_RMA_FEES,
  REQUEST_RMA_FEE,
} from '@sophocles/entities/RmaFee/rmaFeeActions';
import { Map } from 'immutable';

function getState(state, action) {
  switch (action.type) {
    case RECEIVE_RMA_FEES: // Read
      return state.merge(action.rmaFees);
    case DELETE_RMA_FEE: // Delete
      return state.delete(action.rmaFee.toString());
    case EDIT_RMA_FEE: // Update
    case CREATE_RMA_FEE: // Create
    case REQUEST_RMA_FEE:
    case REQUEST_ALL_RMA_FEES:
    default:
      return state;
  }
}

export function rmaFeeReducer(state = Map(), action) {
  switch (action.type) {
    case CREATE_RMA_FEE:
    case DELETE_RMA_FEE:
    case RECEIVE_RMA_FEES:
    case EDIT_RMA_FEE:
    case REQUEST_RMA_FEE:
    case REQUEST_ALL_RMA_FEES:
      return getState(state, action);
    default:
      return state;
  }
}
